import { render, staticRenderFns } from "./ModifyDeliver.vue?vue&type=template&id=234996f7&scoped=true&"
import script from "./ModifyDeliver.vue?vue&type=script&lang=js&"
export * from "./ModifyDeliver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234996f7",
  null
  
)

export default component.exports